import * as React from 'react'
import type { SVGProps, Ref } from 'react'
import { forwardRef } from 'react'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgTriangleArrowDownLeft = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 24 24'
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill={props.color}
      fillRule='evenodd'
      d='M6.926 8.364a1.5 1.5 0 0 1 1.634.325l2.315 2.315 4.564-4.565a1.5 1.5 0 1 1 2.122 2.122l-4.565 4.564 2.314 2.314A1.5 1.5 0 0 1 14.25 18H7.5A1.5 1.5 0 0 1 6 16.5V9.75a1.5 1.5 0 0 1 .926-1.385'
      clipRule='evenodd'
    />
  </svg>
)
const ForwardRef = forwardRef(SvgTriangleArrowDownLeft)
export default ForwardRef
